export const normalizeApiError = (error) => {
  if (error?.isNetworkError) {
    return {
      message: "No internet connection. Please check your network.",
      code: "NO_INTERNET",
    };
  }

  if (!error?.response) {
    return {
      message: "Network error. Please check your internet connection.",
    };
  }

  const { status, data } = error.response;

  if (status === 400) {
    return {
      message: data?.message || data?.errorMessage || "Invalid request. Please check your input.",
    };
  }

  if (status === 401) {
    return {
      message: "Session expired, Please login again.",
      code: "UNAUTHORIZED",
    };
  }

  if (status === 403) {
    return {
      message: "You are not allowed to perform this action.",
    };
  }

  if (status === 429) {
    return {
      message: data?.message || "Maximum request limit reached. Please try again later.",
    };
  }

  if (status >= 500) {
    return {
      message: data?.message || "Server error. Please try again after some time.",
      status,
    };
  }

  return {
    message: data?.message || "Something went wrong",
  };
};
